export default __webpack_public_path__ + "static/media/heart-icon.51584d66.svg";